// Lib
import React, { forwardRef } from 'react';

// Components
import BoardPasswordProtectedContainer from './passwordProtection/BoardPasswordProtectedContainer';
import BoardHierarchyError from './BoardHierarchyError';
import PageLoaderMain from '../components/loaders/PageLoaderMain';

type Props = {
    children: React.ReactNode;
    currentBoardId: string;
    isCurrentBoardFetching: boolean;
    isCurrentBoardFetched: boolean;
    isCurrentBoardDuplicating: boolean;
    isHierarchicalBoardError: boolean;
};

const WorkspacePositioner = forwardRef<HTMLDivElement, Props>(function WorkspacePositionerComponent(
    props,
    workspaceRef,
) {
    const {
        currentBoardId,
        isCurrentBoardFetching,
        isCurrentBoardFetched,
        isCurrentBoardDuplicating,
        isHierarchicalBoardError,
        children,
    } = props;

    // If we determine from the hierarchy of the board that it's in an error state (e.g. the board
    //  appears to be deleted, or not have permissions to view) despite there being no error from the
    //  server, we should force-fetch from the server to see if the error resolves or is confirmed.
    if (isHierarchicalBoardError) return <BoardHierarchyError currentBoardId={currentBoardId} />;

    if ((isCurrentBoardFetching && !isCurrentBoardFetched) || isCurrentBoardDuplicating) return <PageLoaderMain />;

    return (
        <BoardPasswordProtectedContainer>
            <div className="WorkspacePositioner" ref={workspaceRef}>
                {children}
            </div>
        </BoardPasswordProtectedContainer>
    );
});

export default WorkspacePositioner;
